module.exports = require('@atlassian/trello-error-ext') 'Attachment::TypeRestricted'



// WEBPACK FOOTER //
// ./app/scripts/views/attachment/attachment-type-restricted-error.coffee